import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import config from '@/../service/project.config.js';
import { CwxBackend } from '@/types/cwxBackend';

export default {
  async getSystemSettings(): Promise<CwxBackend.ISystemSettingsDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/settings/getSystemSettings`;

    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },
  async getCultureSettings(): Promise<CwxBackend.ICultureSettingsDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/settings/getCultureSettings`;

    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },
  async getCustomCssSettings(): Promise<string> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/settings/getCustomCssSettings`;

    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },
  async getConfiguration(): Promise<CwxBackend.IConfigurationDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/settings/getConfiguration`;

    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },
  async changeLanguage(cultureCode: string): Promise<AxiosResponse> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/settings/changeculture`;

    const queryConfig: AxiosRequestConfig = {
      params: {
        cultureCode: cultureCode,
      },
    };
    return await axios.get(endpointUrl, queryConfig);
  },
};
